import type { OpeningHours } from "../../types";

export const OPENING_HOURS_LABEL = "See our opening hours";

export const OPENING_HOURS_US: OpeningHours = [
  { day: "Mon-Fri", hours: "8am-8pm" },
  { day: "Sat", hours: "Closed" },
  { day: "Sun", hours: "Closed" },
];

export const OPENING_HOURS_UK: OpeningHours = [
  {
    day: "Thu",
    hours: "9.30am-5.30pm",
  },
  {
    day: "Fri",
    hours: "9.00am-5.30pm",
  },
  {
    day: "Sat",
    hours: "9.00am-2.00pm",
  },
  {
    day: "Sun",
    hours: "Closed",
  },
  {
    day: "Mon",
    hours: "9.00am-5.30pm",
  },
  {
    day: "Tue",
    hours: "9.00am-5.30pm",
  },
  {
    day: "Wed",
    hours: "9.00am-5.30pm",
  },
];

export const LOGO_LINK = "https://www.simplybusiness.co.uk/";
